/**
 *  Base Service
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */

import { Component, Injectable, Inject, ReflectiveInjector } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';

import { Event, NotificationType } from '../common/base.data';

/**
 *  Base Service
 */
export abstract class BaseService {

    /**
     * Initialize
     */
    constructor() {
    }

    /**
     * Destroy Service
     */
    public destroy(): void {
    }
}